import React, { useState, useEffect, useRef } from 'react';
import Activo from '../../components/activo/Activo';
import { useTranslation } from 'react-i18next';

const Modal = ({ isOpen, closeModal }) => {

    const dialogRef = useRef(null);
    const [t2, i18n] = useTranslation("global");
    const [inputNombre, setInputNombre] = useState('');
    const [inputApellido, setInputApellido] = useState('');
    const [inputCorreo, setInputCorreo] = useState('');
    const [isValidEmail, setIsValidEmail] = useState(true);
    const [isSubscribed, setIsSubscribed] = useState(false);

    const [t] = useTranslation("global");

    const handleEmailChange = (event) => {
        const { value } = event.target;
        setInputCorreo(value);

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        setIsValidEmail(emailRegex.test(value));
    };

    const handleClose = () => {
        setIsSubscribed(false);

        dialogRef.current?.close();
        closeModal();
    };

    // 🔥 Control real del dialog
    useEffect(() => {
        if (isOpen) {
            dialogRef.current?.showModal();
        } else {
            dialogRef.current?.close();
        }
    }, [isOpen]);

    useEffect(() => {
        setInputNombre('');
        setInputApellido('');
        setInputCorreo('');
    }, []);

    return (
        <dialog ref={dialogRef} className="write-me-modal">

            <section className="write-me-modal__panel">

                {/* CERRAR */}
                <button
                    type="button"
                    className="write-me-modal__close"
                    onClick={handleClose}
                >
                    ✕
                </button>

                <div className="write-me-modal__form">

                    <div className="write-me-modal__body">

                        {
                            !isSubscribed ? (
                                <>

                                    <h2 className="write-me-modal__title">
                                        {(t2('general.suscribirsel'))}
                                    </h2>

                                    {/* NOMBRE */}
                                    <label className="write-me-modal__field">
                                        <span className="write-me-modal__field-label">
                                            {t('forms.name')}*
                                        </span>

                                        <input
                                            type="text"
                                            value={inputNombre}
                                            onChange={(e) => setInputNombre(e.target.value)}
                                            className="write-me-modal__field-control"
                                            required
                                        />
                                    </label>

                                    {/* APELLIDO */}
                                    <label className="write-me-modal__field">
                                        <span className="write-me-modal__field-label">
                                            {t('forms.last_name')}
                                        </span>

                                        <input
                                            type="text"
                                            value={inputApellido}
                                            onChange={(e) => setInputApellido(e.target.value)}
                                            className="write-me-modal__field-control"
                                        />
                                    </label>

                                    {/* EMAIL */}
                                    <label className="write-me-modal__field">
                                        <span className="write-me-modal__field-label">
                                            {t('forms.email')}*
                                        </span>

                                        <input
                                            type="email"
                                            value={inputCorreo}
                                            onChange={handleEmailChange}
                                            className="write-me-modal__field-control"
                                            required
                                        />
                                    </label>

                                    <div>
                                        <Activo
                                            nombre={inputNombre}
                                            apellido={inputApellido}
                                            correo={inputCorreo}
                                            valid={isValidEmail}
                                            onSuccess={() => {

                                                setInputNombre('');
                                                setInputApellido('');
                                                setInputCorreo('');
                                            
                                                setIsSubscribed(true);
                                            
                                            }}
                                        />
                                    </div>

                                    <p className="write-me-modal__legal">
                                        {t('forms.accept3')}
                                    </p>

                                </>
                            ) : (
                                <div className="write-me-modal__success">

                                    <img className='img-success-pal' src='/assets/img2026/palomita.svg' />

                                    <h2 className="write-me-modal__title">
                                        {i18n.language === "en"
                                            ? "Thank you for subscribing."
                                            : "Gracias por suscribirte al blog."}
                                    </h2>



                                    <button
                                        type="button"
                                        className="btnSuscri subscribe-modal__submit typo-book-title"
                                        onClick={handleClose}
                                    >
                                        {i18n.language === "en"
                                            ? "Close"
                                            : "Cerrar"}
                                    </button>

                                </div>
                            )
                        }

                    </div>

                </div>
            </section>
        </dialog>
    );
};

export default Modal;